import React from 'react'
import Section from "../../Components/Section/Section";
import styles from "./home.module.css"
import heroImage from "../../assets/heroImage.png"
import { LuChevronsDown } from "react-icons/lu";
import { Link } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import {useIsSmallScreen} from '../../hooks/useIsSmallScreen';
function Hero() {

    const handleExplore = () => {
        document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
    };

    const isSmallScreen = useIsSmallScreen();

    return (
        <Section wide>
            <div className={styles.heroContainer}>
                <div className={styles.heroContentLeft}>
                    <div data-reveal className={styles.heroHeader}>
                        <h2>Nails by</h2>
                        <h1>Astraea</h1>
                    </div>
                    <div data-reveal className={styles.heroSubheader}>
                        <p>Experience stunning designs, an enchanting atmosphere, and personalized care at every visit.</p>
                    </div>
                    <div data-reveal className={styles.actionRow}>
                        <Link to="/book" className={styles.actionPrimary}>Book Appointment</Link>
                        <NavHashLink smooth to="/home#services" className={styles.actionSecondary}>View Services</NavHashLink>
                    </div>
                </div>
                <div className={styles.heroContentRight}>
                    <div data-reveal className={styles.heroImageWrapper}>
                        <img src={heroImage} alt="Hero" />
                    </div>
                </div>
            </div>
            {!isSmallScreen && (
                <button className={styles.exploreButton} onClick={handleExplore}>
                    <p>Explore</p>
                    <LuChevronsDown size={28} />
                </button>
            )}
        </Section>
    )
}

export default Hero
